// extracted by mini-css-extract-plugin
module.exports = {"container":"_2FF7926sgor39ATzbiV9_P","value":"_2jJ_WrLWnUj-OYrIdyQyEb","status":"RBRKzwq7mwp7O0rX9wNv4"};